import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
  IsNumber,
  IsArray,
  ValidateNested,
} from "@/utils/type-vaildator";
import api from "./api";

/** 原始接口单条 */
export interface AdminVideoTemplateListItemResponse {
  id: string;
  style_id: string;
  name: string;
  cover_url: string;
  scene: string;
  demo_url: string;
  status: string;
}

/** 原始接口响应 */
export interface AdminVideoTemplateListResponse {
  list: AdminVideoTemplateListItemResponse[];
  count: number;
}

export interface AdminVideoTemplateListFilterInput {
  templateId?: string;
  agentId?: string;
}

/** 请求参数（camelCase，与业务层一致）；template_type 由接口写死为 VIDEO */
export interface AdminVideoTemplateListRequest {
  filter?: AdminVideoTemplateListFilterInput;
  page: number;
  pageSize: number;
}

export class AdminVideoTemplateListItemData {
  @Required("id cannot be empty")
  @IsNumber("id must be a number")
  id: number;

  @Required("styleId cannot be empty")
  @IsString("styleId must be a string")
  styleId: string;

  @Required("name cannot be empty")
  @IsString("name must be a string")
  name: string;

  @Required("coverUrl cannot be empty")
  @IsString("coverUrl must be a string")
  coverUrl: string;

  @IsNumber("templateResource must be a number")
  templateResource: number;

  @Required("scene cannot be empty")
  @IsString("scene must be a string")
  scene: string;

  /** 接口可能返回空字符串，不使用 @Required */
  @IsString("demoUrl must be a string")
  demoUrl: string;

  @IsString("status must be a string")
  status: string;
}

export class AdminVideoTemplateListData {
  @IsArray("list must be an array")
  @ValidateNested(AdminVideoTemplateListItemData, "list item validation failed")
  list: AdminVideoTemplateListItemData[];

  @Required("count cannot be empty")
  @IsNumber("count must be a number")
  count: number;
}

const transformAndValidate = (
  response: AdminVideoTemplateListResponse
): AdminVideoTemplateListData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, AdminVideoTemplateListData);
  } catch (error: unknown) {
    const message = error instanceof Error ? error.message : String(error);
    console.error("Admin video template list validation failed:", message);
    throw error;
  }
};

/** 后台视频模板列表 */
export const adminVideoTemplateList = async ({
  page,
  pageSize,
  filter,
}: AdminVideoTemplateListRequest): Promise<AdminVideoTemplateListData> => {
  const response = await api.post<AdminVideoTemplateListResponse>("/template/list", {
    filter: {
      template_type: "VIDEO",
      template_id: filter?.templateId,
      agent_id: filter?.agentId,
    },
    page,
    page_size: pageSize,
  });
  return transformAndValidate(response.data);
};
